import { render } from "./BankAdd.vue?vue&type=template&id=f382a184&scoped=true"
import script from "./BankAdd.vue?vue&type=script&lang=js"
export * from "./BankAdd.vue?vue&type=script&lang=js"

import "./BankAdd.vue?vue&type=style&index=0&id=f382a184&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f382a184"]])

export default __exports__